import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import validateToken from '../contexts/ValidateToken';

const getAuthToken = () => {
  return localStorage.getItem('authToken');
};

const setupInterceptors = (instance: AxiosInstance) => {
  instance.interceptors.request.use(
    async config => {
      const token = getAuthToken();
      if (token) {
        const isValid = await validateToken(token);
        if (!isValid) {
          localStorage.removeItem('authToken');
          // eslint-disable-next-line no-param-reassign
          delete config.headers.Authorization; // Remove the Authorization header
          return Promise.reject(new Error('Invalid token'));
        }
        // eslint-disable-next-line no-param-reassign
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    error => {
      return Promise.reject(error);
    }
  );
};

console.log('🔍 REACT_APP_ENV:', process.env.REACT_APP_ENV);
console.log('🔍 Checking condition:', process.env.REACT_APP_ENV === "production");

const apiUrl = process.env.REACT_APP_ENV === "production"
  ? "https://api.mywishes.co.uk/v1"
  : "https://api.staging.mywishes.co.uk/v1";

// Main API instance
const axiosIns: AxiosInstance = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('🚀 Main API URL:', apiUrl);

// Secondary API instance
console.log('🔍 REACT_APP_ENV:', process.env.REACT_APP_ENV);

const mongoUrl = process.env.REACT_APP_ENV === "production"
  ? "https://mongo.mywishes.co.uk/v1"
  : "https://mongo.staging.mywishes.co.uk/v1";

// Secondary API instance
const anotherAxiosIns: AxiosInstance = axios.create({
  baseURL: mongoUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

console.log('🚀 Mongo API URL:', mongoUrl);

// Setup interceptors for both instances
setupInterceptors(axiosIns);
setupInterceptors(anotherAxiosIns);

export { axiosIns, anotherAxiosIns };
